import ExcelDownComponent from "@/pcomponents/common/excel/down";
import { useRef, forwardRef, useImperativeHandle } from 'react';
import strFunc from '@/lib/lyg/string';
import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";
import getXcolumnJson from "./xcolumn/list";

const OrderListExcelDown = forwardRef((props: any, ref) => {
  let myProps = {
    infoArr: [],
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const ExcelDownComponentRef = useRef<any>();
  let select_order_product_type = ShopFunc.select_order_product_type;
  let select_order_state_arr = ShopFunc.select_order_state_arr;
  let select_in_out_arr = ShopFunc.select_in_out_arr;
  let select_pay_sort = ShopFunc.select_pay_sort;

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    goExcelDown
  }))

  const goExcelDown = (inData:any) => {
    let opt_obj={
      infoArr:myProps.infoArr,
      ...inData
    };
    if (ExcelDownComponentRef.current) {
      let tmp_info_arr: any = [];

      for (let i = 0; i < opt_obj.infoArr.length; i++) {
        let info = opt_obj.infoArr[i];

        let find_obj = select_order_state_arr.find((el: any) => el.value == info.a_state);
        if (find_obj) {
          info.row_view_state = find_obj.text;
        }
        let pay_sort_str = "";
        for (let i = 0; i < select_pay_sort.length; i++) {
          if (select_pay_sort[i].value == info.a_pay_sort) {
            pay_sort_str = select_pay_sort[i].text;
          }
        }
        info.row_view_payt_sort = pay_sort_str;

        if (info.order_det_arr.length > 0) {
          for (let j = 0; j < info.order_det_arr.length; j++) {
            let det_info = info.order_det_arr[j];
            let tmp_info = {
              ...info,
            };
            if (j != 0) {
              // tmp_info["a_date"] = "";
              // tmp_info["mcomp_name"] = "";
              // tmp_info["a_user_name"] = "";
              tmp_info["a_title"] = "";
              // tmp_info["row_view_state"] = "";
              // tmp_info["row_view_payt_sort"] = "";
              // tmp_info["order_det_amount"] = "";
              // tmp_info["order_det_price"] = "";
            }

            let product_type_text = "";
            for (let sel_i = 0; sel_i < select_order_product_type.length; sel_i++) {
              let tmp_obj = select_order_product_type[sel_i];
              if (tmp_obj.value == det_info.a_product_type) {
                product_type_text = tmp_obj.text;;
                break;
              }
            }

            tmp_info["det_sort"] = product_type_text;
            tmp_info["det_product_name"] = det_info.a_product_name;
            tmp_info["det_buyer_name"] = det_info.a_buy_user_name;
            tmp_info["det_amount"] = det_info.a_amount;
            tmp_info["det_money"] = det_info.a_price_sum;

            tmp_info_arr.push(tmp_info);
          }
        }
      }

      ExcelDownComponentRef.current.setInitData({
        infoArr: tmp_info_arr
      });
      setTimeout(() => {
        ExcelDownComponentRef.current.goDownExcel();
      }, 100);
    }
  };

  return (
    <>
      <ExcelDownComponent
        ref={ExcelDownComponentRef}
        xColumnArr={xColumnArr}
        is_add_example={false}
      ></ExcelDownComponent>
    </>
  );
});
export default OrderListExcelDown;